import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BulletList, BulletListItem, Callout, Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetSaveErrorsCalloutTID = (parentTestId)=>getTestIds(parentTestId);
function CustomerNamesList(param) {
    let { entries } = param;
    return /*#__PURE__*/ _jsx(BulletList, {
        children: entries.map((entry, index)=>/*#__PURE__*/ _jsx(BulletListItem, {
                variant: "paragraph3",
                children: entry.customerName
            }, "".concat(entry.customerName, "-").concat(index)))
    });
}
export function SaveErrorsCallout(param) {
    let { saveErrors, testId } = param;
    const { t: resultsTexts } = useLocaleKeys('pages.importClients.results');
    const { SaveErrorsCalloutTestIds: TID } = useMemo(()=>GetSaveErrorsCalloutTID(testId), [
        testId
    ]);
    const missingContacts = saveErrors.filter((entry)=>entry.creationStatus === 'created');
    const notCreated = saveErrors.filter((entry)=>entry.creationStatus === 'not_created');
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        testId: TID.Root(),
        children: [
            missingContacts.length > 0 && /*#__PURE__*/ _jsx(Callout, {
                skin: "standard",
                intent: "error",
                testId: TID.MissingContacts(),
                footer: /*#__PURE__*/ _jsx(CustomerNamesList, {
                    entries: missingContacts
                }),
                children: resultsTexts.saveErrorsHeader()
            }),
            notCreated.length > 0 && /*#__PURE__*/ _jsx(Callout, {
                skin: "standard",
                intent: "error",
                testId: TID.NotCreated(),
                footer: /*#__PURE__*/ _jsx(CustomerNamesList, {
                    entries: notCreated
                }),
                children: resultsTexts.saveErrorsNotCreatedHeader()
            })
        ]
    });
}
